/**
 * Unified Integrations Page - S001 & S002
 * Single page with tabs for all integrations (Segment, Jira, etc.)
 */

import React, { useState } from 'react';

// Import individual integration components
import { SegmentIntegration } from '../components/integrations/SegmentIntegration';
import { JiraIntegration } from '../components/integrations/JiraIntegration';
import { ConfluenceIntegration } from '../components/integrations/ConfluenceIntegration';
import { SlackIntegration } from '../components/integrations/SlackIntegration';

type IntegrationType = 'segment' | 'jira' | 'confluence' | 'slack';

export function IntegrationsPage() {
  const [activeTab, setActiveTab] = useState<IntegrationType>('segment');

  const tabs: Array<{ id: IntegrationType; name: string; icon: string; disabled?: boolean }> = [
    { id: 'slack', name: 'Slack', icon: '💬' },
    { id: 'segment', name: 'Segment CDP', icon: '📊' },
    { id: 'jira', name: 'Jira', icon: '🎫' },
    { id: 'confluence', name: 'Confluence', icon: '📝' },
  ];

  return (
    <div className="mx-auto max-w-7xl">
      <div className="mb-6">
        <h2 className="text-3xl font-bold text-black dark:text-white">
          Integrations
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
          Connect external tools and services to GP-ads
        </p>
      </div>

      {/* Tabs */}
      <div className="mb-6 border-b border-stroke dark:border-strokedark">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => !tab.disabled && setActiveTab(tab.id)}
              disabled={tab.disabled}
              className={`
                flex items-center gap-2 border-b-2 py-4 px-1 text-sm font-medium
                ${
                  activeTab === tab.id
                    ? 'border-primary text-primary'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
                }
                ${tab.disabled ? 'opacity-50 cursor-not-allowed' : ''}
              `}
            >
              <span className="text-xl">{tab.icon}</span>
              {tab.name}
              {tab.disabled && <span className="text-xs">(Coming Soon)</span>}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-6">
        {activeTab === 'slack' && <SlackIntegration />}
        {activeTab === 'segment' && <SegmentIntegration />}
        {activeTab === 'jira' && <JiraIntegration />}
        {activeTab === 'confluence' && <ConfluenceIntegration />}
      </div>
    </div>
  );
}
